module.exports = "/assets/30cab4d9a3bd1a0b21cc31ea26aa4a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/NR.png
// module id = 1656
// module chunks = 0